export default __webpack_public_path__ + "static/media/ba.b79664d5.svg";